import { FC } from "react"
import { Star } from "lucide-react"
import { LoanOfficer, ZillowReview } from "../../../../types"
import LoanOfficerOverview from "./LoanOfficerOverview"
import ZillowReviewsList from "../../zillow-reviews-list"

interface Props {
  loanOfficer: LoanOfficer | null
  review?: ZillowReview[]
}

const LoanOfficerDetails: FC<Props> = ({ loanOfficer, review }) => {
  return (
    <div className="p-8 bg-slate-50 min-h-full space-y-6">
      <LoanOfficerOverview loanOfficer={loanOfficer as LoanOfficer} />
      {review && review.length > 0 && (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 animate-fade-slide-in opacity-0 [animation-delay:600ms]">
          <div className="flex items-center gap-2 mb-4">
            <span className="text-primary-500">
              <Star size={20} />
            </span>
            <h2 className="font-serif text-lg font-semibold text-slate-800">
              Zillow Reviews
            </h2>
          </div>
          <ZillowReviewsList reviews={review} hideTitle />
        </div>
      )}
    </div>
  )
}

export default LoanOfficerDetails
